export const PAGE_LIST_LIMIT = 20; 
// eslint-disable-next-line import/no-anonymous-default-export
export default { PAGE_LIST_LIMIT };
